import * as types from "./dashboardActionTypes";

const stateObject = {
  isLoading: false,
  isSuccess: false,
  payload: {},
  error: null,
  isError: false
};

const initialState = {
  dashboard: { ...stateObject },
  closeJobMetadata: { ...stateObject },
  closeJobState: { ...stateObject },
  shState: { ...stateObject },
  shareJobState: { ...stateObject },
  markJobStory: { ...stateObject },
  showHiringCertificate: false,
  currentActiveTab: "",
  closedJobDetails: {}
};

export default function dashboardReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_DASHBOARD_LOADING:
      return {
        ...state,
        dashboard: {
          ...state.dashboard,
          isLoading: true,
          isSuccess: false
        }
      };
    case types.GET_DASHBOARD_SUCCESS:
      return {
        ...state,
        dashboard: {
          ...state.dashboard,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.GET_DASHBOARD_FAILURE:
      return {
        ...state,
        dashboard: {
          ...state.dashboard,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        }
      };

    case types.GET_CLOSE_JOB_LOADING:
      return {
        ...state,
        closeJobMetadata: {
          ...state.closeJobMetadata,
          isLoading: true
        }
      };
    case types.GET_CLOSE_JOB_SUCCESS:
      return {
        ...state,
        closeJobMetadata: {
          ...state.closeJobMetadata,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.GET_CLOSE_JOB_FAILURE:
      return {
        ...state,
        closeJobMetadata: {
          ...state.closeJobMetadata,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        }
      };

    case types.CLOSE_JOB_LOADING:
      return {
        ...state,
        closeJobState: {
          ...stateObject,
          isLoading: true
        }
      };
    case types.CLOSE_JOB_SUCCESS:
      return {
        ...state,
        closeJobState: {
          ...state.closeJobState,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.CLOSE_JOB_FAILURE:
      return {
        ...state,
        closeJobState: {
          ...state.closeJobState,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        }
      };

    case types.SET_ACTIVE_TAB:
      return {
        ...state,
        currentActiveTab: action.activeTab
      };

    case types.STILL_HIRING_LOADING:
      return {
        ...state,
        shState: {
          ...state.shState,
          isLoading: true
        }
      };
    case types.STILL_HIRING_SUCCESS:
      return {
        ...state,
        shState: {
          ...state.shState,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.STILL_HIRING_FAILURE:
      return {
        ...state,
        shState: {
          ...state.shState,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        }
      };

    case types.SHARE_JOB_LOADING:
      return {
        ...state,
        shareJobState: {
          ...state.shareJobState,
          isLoading: true
        }
      };
    case types.SHARE_JOB_SUCCESS:
      return {
        ...state,
        shareJobState: {
          ...state.shareJobState,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.SHARE_JOB_FAILURE:
      return {
        ...state,
        shareJobState: {
          ...state.shareJobState,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        }
      };

    case types.MARK_JOB_STORY_READ_LOADING:
      return {
        ...state,
        markJobStory: {
          ...state.markJobStory,
          isLoading: true
        }
      };
    case types.MARK_JOB_STORY_READ_SUCCESS:
      return {
        ...state,
        markJobStory: {
          ...state.markJobStory,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.MARK_JOB_STORY_READ_FAILURE:
      return {
        ...state,
        markJobStory: {
          ...state.markJobStory,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        }
      };

    case types.SHOW_HIRING_CERTIFICATE_DRAWER:
      return {
        ...state,
        showHiringCertificate: action.payload
      };

    case types.CLOSED_JOB_DETAILS:
      return {
        ...state,
        closedJobDetails: action.payload
      };
    default:
      return state;
  }
}
